<template>
    <div id="HomeDiv">
            <HeaderVue />
            <div class="banner-section">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-5">
                            <div class="banner-text">
                                <h3 class="black-color" >Your blood tests, Your choice of labs, at Your home</h3>
                                <h4>Affordable tests at great convenience</h4>
                                <p class="mt-4">Our service is currently in Chennai & Bengaluru only</p>
                                <div class="banner-fields mb-4">
                                    <!--<input type="text" class="form-control form-control-lg rounded-corner text-center" 
                                        ref="pincode"  
                                        placeholder="Enter Locality or Pincode" 
                                        aria-label="" 
                                        name="x" 
                                        list="mycarousel" 
                                        autocomplete="off" 
                                        minlength="3" 
                                        v-model="query" 
                                        v-on:keyup="searchLocation"
                                        v-on:keyup.enter="searchLocation" 
                                        v-on:blur="closeBlock()"
                                        v-on:focus="$refs.pincode.select()">
                                        <ul class="scrollbar" v-bind:style="{ display: onBlurKey}">
                                            <li class="text-left" v-for="(item, index) in items" :key="index" v-on:click.self="selectLocation($event, item)">
                                                {{item.locationName+'-'+item.locationZipCode}}
                                            </li>
                                            <li class="text-center" v-if="items.length === 0"> --- No Locations ---</li>
                                        </ul>-->
                                    <!--<button class="btn btn-lg btn-primary" ref="pincodeSubmit" type="button" v-on:click.self="goTest()" v-on:keyup.enter="goTest()" :disabled="!selectedLocation">-->
                                    <!--<button class="btn btn-lg btn-primary w-75" ref="pincodeSubmit" type="button" v-on:click.self="$router.push({ path: '/test' })">-->
                                    <button class="btn btn-lg btn-primary w-75" ref="pincodeSubmit" type="button" v-on:click.self="$router.push({ path: '/lab' })">
                                        Book Test
                                    </button>
                                </div>
                                <img src="static/images/offer.svg" class="offer-img" alt="">
                                <!-- <span>Location: {{this.address.route}}</span> -->
                            </div>
                        </div>
                        <div class="col-sm-7">
                            <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src="static/images/banner.svg" class="d-block w-100" alt="">
                                    </div>
                                    <div class="carousel-item">
                                        <img class="d-block w-100" src="static/images/banner-old.svg" alt="Second slide">
                                    </div>
                                </div>
                                <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"><i class="fa fa-angle-double-left"></i></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"><i class="fa fa-angle-double-right"></i></span>
                                    <span class="sr-only">Next</span>
                                </a>
                            </div>
                            <!-- <img src="images/banner.svg" class="img-fluid section-img" alt=""> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="section" style="padding-top: 80px;">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <h2 class="section-title text-center">Why Labotist</h2>
                            <div class="why-labotist">
                                <div class="future-list">
                                    <span class="sprites sprite-pickup align-center"></span>
                                    <p>Free Home
                                        <br> Sample Pickup</p>
                                </div>
                                <div class="future-list">
                                    <span class="sprites sprite-phlebotomists align-center"></span>
                                    <p>Trained
                                        <br> Phlebotomists</p>
                                </div>
                                <div class="future-list">
                                    <span class="sprites sprite-shield align-center"></span>
                                    <p>Technology enabled & safe
                                        <br> sample collection process</p>
                                </div>
                                <div class="future-list">
                                    <span class="sprites sprite-star align-center"></span>
                                    <p>Know
                                        <br> your labs better</p>
                                </div>
                                <div class="future-list">
                                    <span class="sprites sprite-mobile align-center"></span>
                                    <p>Get
                                        <br> Online Reports</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="blue-bg">
                <div class="section">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6">
                                <img src="static/images/kit.svg" class="img-fluid section-img kit-img" alt="">
                            </div>
                            <div class="col-sm-6">
                                <h2 class="section-title">We created a specially designed box and universal kit for you to ensure accurate results</h2>
                                <ul class="kit-list">
                                    <li>Disposable</li>
                                    <li>Pre-bar coded tubes</li>
                                    <li>Hygienic sample draw accessories</li>
                                    <li>Insulated box for safe transportation of samples</li>
                                    <li>Temperature controlled to ensure sample quality</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <h2 class="section-title text-center">How Labotist Works?</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="white-box">
                                    <div class="white-content">
                                        <span class="sprites sprite-one"></span>
                                        <h5>Choose test and select lab</h5>
                                        <p>Select the right test and the best lab based on quality, turn around time, method of
                                            testing & price, and book your test digitally </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="white-box">
                                    <div class="white-content">
                                        <span class="sprites sprite-two"></span>
                                        <h5>Sample collected at home</h5>
                                        <p>A trained phlebotomist will come to your home at the scheduled time to collect the sample in a safe & hygienic method and deliver it to the choosen lab making it very convenient for you.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="white-box">
                                    <div class="white-content">
                                        <span class="sprites sprite-three"></span>
                                        <h5>Safe, Secure & Accurate</h5>
                                        <p>The technology driven sample collection process and transportation of samples in a specially designed box, ensures superior sample quality, enabling accurate results.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="green-bg">
                <div class="section dashboard-online">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-5">
                                <h2 class="section-title">Your personal
                                    <br> dashboard online</h2>
                                <p class="theme-lineheight">All lab reports, irrespective of the lab at which you get your tests done, will be stored under
                                    one registered account securely. You will also be able to manage your records or that of
                                    family members under one account. Labotist provides easy access to health records and history whenever and whereever needed.</p>
                            </div>
                            <div class="col-sm-7">
                                <img src="static/images/responsive.svg" class="img-fluid section-img responsive-img" alt="">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <h2 class="section-title text-center">Customer Testimonials</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 col-lg-4">
                                <div class="testimonial-box">
                                    <p>The lab test search and selection of labs was very simple. I was able to make a well informed decision on the lab instead of by default opting to go the nearest one or the one which my doctor asks me to go</p>
                                </div>
                                <div class="testimonial-profile clearfix">
                                    <div class="testimonial-dp" style="background-image: url(static/images/kumaresh.png); background-size: 100%;">
                                    </div>
                                    <h5>Kumaresh</h5>
                                    <p>IT Engineer</p>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-4">
                                <div class="testimonial-box">
                                    <p>You guys rock. Such a convenient way to research, order and get samples collected and delivered professionally..all just through a few clicks. A great experience.</p>
                                </div>
                                <div class="testimonial-profile clearfix">
                                    <div class="testimonial-dp" style="background-image: url(static/images/imran.png); background-size: 100%;">
                                    
                                    </div>
                                    <h5>Imran</h5>
                                    <p>Director of Photography</p>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-4">
                                <div class="testimonial-box">
                                    <p>First time I ever felt pampered during the blood draw process :). Quick, easy & hygienic. Technology working at its best to ensure safety, quality and convenience.</p>
                                </div>
                                <div class="testimonial-profile clearfix">
                                    <div class="testimonial-dp" style="background-image: url(static/images/hemavathy.png); background-size: 100%;">

                                    </div>
                                    <h5>Hemavathy</h5>
                                    <p>Housewife</p>
                                </div>
                            </div>
                        </div>
                        <!--<div class="row">
                            <div class="col-sm">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination">
                                        <li class="page-item">
                                            <a class="page-link" href="#">
                                                <span class="sprites sprite-right-arrow"></span>
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link" href="#">
                                                <span class="sprites sprite-line-green"></span>
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link" href="#">
                                                <span class="sprites sprite-line-grey"></span>
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link" href="#">
                                                <span class="sprites sprite-line-grey"></span>
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link" href="#">
                                                <span class="sprites sprite-left-arrow"></span>
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>-->
                    </div>
                </div>
            </div>

            <!-- <div class="contact-info">
                <div class="container">
                    <div class="row text-center">
                        <div class="col-sm-6">
                            <span class="sprites sprite-mail align-center"></span>
                            <p><strong class="black-color">Wait Time:</strong> within 24 hours.</p>
                            <p><strong class="black-color">Questions or Comments?</strong></p>
                            <p>Email us: 
                                <a href="mailto:support@labotist.com" target="_top"> support@labotist.com </a>
                            </p>
                        </div>
                        <div class="col-sm-6">
                            <span class="sprites sprite-call align-center"></span>
                            <p><strong class="black-color">All days 9AM - 6PM</strong></p>
                            <p>Call: <a href="tel:+919025662566">+91 90256 62566</a></p>
                        </div>
                    </div>
                </div>
            </div> -->
            <HomeFooterVue />
            <div class="fixed-footer">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-1">
                            <h5 class="text-sm-left foot-title text-nowrap">
                                <b>
                                    <span class="blue-color">Our Lab</span>
                                    <br class="sm-hidden">
                                    <span class="green-color">Partners</span>
                                </b>
                            </h5>
                            <div class="left-line"></div>
                        </div>
                        <div class="col-sm-11">
                            <div class="slider">
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/medall.jpg" alt="Medall Health Care Pvt Ltd">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/metroplis.png" alt="Lister Metropolis Healthcare Limited">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/bioline.jpg" alt="Bio Line Laboratory">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/techmed.jpg" alt="Techmed Health Centre & Diagnostic">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/srl.png" alt="Specialtys Medical Diagnostic(SRL Diagnostics)">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/vrr.jpg" alt="VRR Diagnostics">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/medcis.png" alt="Medcis Pathlabs India Pvt. Ltd">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/pathcare.jpg" alt="Path Care Labs Pvt. Ltd">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/aarthi.jpg" alt="Aarthi Scans And Labs">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/primex.png" alt="Primex Scans and Labs">
                                    </div>
                                </div>
                                <!--<div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/american.jpg" alt="The American Clinical laboratories">
                                    </div>
                                </div>-->
                                <!--<div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/best.png" alt="Best Diagno labs">
                                    </div>
                                </div>-->
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/microbiological.jpg" alt="Microbiological Laboratory">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/hitech.jpg" alt="Hitech Diagnostic Centre">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/asian.jpg" alt="Asian Diagnostics">
                                    </div>
                                </div>
                                <div class="slide">
                                    <div class="card">
                                        <img class="card-img-top" src="static/images/client/diagnolabs.jpg" alt="Diagno labs Pvt Ltd">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import HomeFooterVue from '@/components/web/HomeFooter'
import Vue from 'vue'

export default {
  name: 'Home',
  components: {
    HeaderVue,
    HomeFooterVue
  },
  beforeCreate () {
    this.query = this.$localStorage.get('location')
  },
  created () {
    setTimeout(function () {
      $('.slider').bxSlider({
        slideWidth: 'auto',
        minSlides: 1,
        maxSlides: 6,
        moveSlides: 6,
        slideMargin: 10,
        auto: true,
        autoControls: true
      })
      $("#carouselExampleControls").carousel()
      var footHeight = $('.fixed-footer').outerHeight()
      $('body').css('margin-bottom', footHeight)
    }, 100)
  },
  mounted: function () {
    this.$hidePageLoading()
  },
  data () {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    }
  },
  methods: {
    goTest: function () {
      this.query = this.selectedLocation ? this.selectedLocation.locationName + '-' + this.selectedLocation.locationZipCode : ''
      if (!this.selectedLocation) {
        return false
      }
      this.$localStorage.set('location', this.selectedLocation, 0)
      this.$localStorage.set('pincode', this.selectedLocation.locationZipCode, 0)
      Vue.analytics.fbq.event('ViewContent', {
        content_ids: this.selectedLocation.locationId,
        content_name: this.selectedLocation.locationZipCode,
        contents: {
          id: this.selectedLocation.locationId,
          location: this.selectedLocation.locationName,
          zipcode: this.selectedLocation.locationZipCode
        },
        content_type: 'PINCODE_ENTERED'
      })
      this.$router.push({ path: '/lab' })
    //   this.$router.push({ path: '/test' })
    },
    searchLocation: function (event) {
      if (event.key === 'Control' || event.key === 'Tab') {
        return false
      }
      this.onBlurKey = 'block'
      this.selectedLocation = undefined
      this.$localStorage.remove('location')
      this.$localStorage.remove('pincode')
      if (this.query.length < 3) {
        this.onBlurKey = 'none'
        this.items = []
        return false
      }
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'keyword': this.query
          }
          Promise.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            console.log(res)
            if (res.response_code === 0) {
              this.items = res.response
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    closeBlock: function () {
      setTimeout(function () {
        this.onBlurKey = 'none'
      }.bind(this), 300)
    },
    selectLocation: function (event, obj) {
      this.selectedLocation = undefined
      this.selectedLocation = obj
      this.selectedPincode = obj.locationZipCode
      this.query = obj.locationName + '-' + obj.locationZipCode
      this.items = []
      this.onBlurKey = 'none'
      setTimeout(function () {
        this.$refs.pincodeSubmit.focus()
      }.bind(this), 300)
    }
  },
  watch: {
    address: function (val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/web/Home.vue